import { useState } from "react";
import {
    postVerificationCode,
    findUserId,
    postPasswordVerify,
    postPasswordChange,
} from "api/user";
import TabHeader from "components/common/TabHeader";
import SubHeader from "components/common/SubHeader";
import { useNavigate } from "react-router-dom";

const FindIdAndPW = () => {
    const navigate = useNavigate();
    const [selectedTab, setSelectedTab] = useState("아이디 찾기");
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [myId, setMyId] = useState(null);
    const [isSendCode, setIsSendCode] = useState(false);
    const [verificationCode, setVerificationCode] = useState(""); // 인증번호
    const [helpTxt, setHelpTxt] = useState(null);
    const [isVerified, setIsVerified] = useState(false); // 인증번호 검증 여부
    const [newPassword, setNewPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false); // 로딩 상태 추가

    const sendVerificationCode = () => {
        const isValidInput =
            selectedTab === "아이디 찾기"
                ? name.length > 0
                : myId && myId.length > 0;

        if (isLoading || isSendCode || !isValidInput) {
            return;
        }

        setIsLoading(true);
        setHelpTxt(null);

        const tab =
            selectedTab === "아이디 찾기" ? "find-user-id" : "password_reset";
        const params =
            selectedTab === "아이디 찾기"
                ? { name: name, hp: phone }
                : { user_id: myId, hp: phone };

        postVerificationCode(tab, params)
            .then((res) => {
                if (res?.code) {
                    setIsSendCode(true);
                    setHelpTxt(null);
                } else if (res?.message) {
                    setHelpTxt(res.message);
                } else {
                    setHelpTxt(
                        "인증번호 발송에 실패했습니다. 다시 시도해주세요."
                    );
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    // 비밀번호 찾기 인증번호 검증 로직
    const handleVerifyCodeForPassword = () => {
        postPasswordVerify(myId, phone, verificationCode).then((res) => {
            if (res.code === "0000") {
                setIsVerified(true);
                setHelpTxt(null);
            } else {
                setHelpTxt(res.message);
            }
        });
    };

    const handleFindButton = () => {
        if (isLoading) return;

        if (selectedTab === "아이디 찾기") {
            setIsLoading(true);
            setHelpTxt(null);

            findUserId(name, phone, verificationCode)
                .then((res) => {
                    if (res.user_id) {
                        setMyId(res.user_id);
                        setHelpTxt(null);
                    } else if (res.message) {
                        setHelpTxt(res.message);
                    }
                })
                .catch((err) => {
                    setHelpTxt(
                        "아이디 찾기에 실패했습니다. 다시 시도해주세요."
                    );
                })
                .finally(() => {
                    setIsLoading(false);
                });
        } else {
            postPasswordChange(phone, newPassword).then((res) => {
                if (res.code === "0000") {
                    setHelpTxt(null);
                    resetForm(selectedTab);
                    alert(
                        "비밀번호 재설정이 완료되었습니다. 로그인 페이지로 이동합니다."
                    );
                    navigate("/login", { replace: true });
                } else {
                    setHelpTxt(res.message);
                }
            });
        }
    };

    const resetForm = (tab) => {
        setName("");
        setPhone("");
        setVerificationCode("");
        setIsSendCode(false);
        setHelpTxt(null);
        setIsVerified(false);
        setNewPassword("");
        setIsLoading(false);

        if (tab === "아이디 찾기") {
            setMyId(null);
        } else {
            setMyId("");
        }
    };

    return (
        <>
            <SubHeader />
            <TabHeader
                menus={["아이디 찾기", "비밀번호 찾기"]}
                defaultTab={selectedTab}
                setSelectedTab={(tab) => {
                    setSelectedTab(tab);
                    resetForm(tab);
                }}
                style={{ top: 59 }}
            />

            {selectedTab === "아이디 찾기" ? (
                <div className="find-id-and-pw-wrap">
                    <h2 className="title">가입 정보로 아이디를 확인하세요.</h2>
                    {myId === null ? (
                        <>
                            <div className="input-form">
                                <input
                                    className="input input-has-gutter"
                                    placeholder="가입한 이름을 입력하세요"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    disabled={isLoading}
                                />
                            </div>
                            <div className="input-form input-has-button">
                                <div className="input-has-button">
                                    <input
                                        className="input input-has-gutter"
                                        placeholder="휴대폰 번호를 -없이 입력하세요"
                                        value={phone}
                                        onChange={(e) =>
                                            setPhone(e.target.value)
                                        }
                                        disabled={isLoading}
                                    />
                                    <button
                                        className={`btn btn-fit btn-border-8 ${
                                            isSendCode ? "disabled" : ""
                                        }`}
                                        onClick={sendVerificationCode}
                                        disabled={isLoading}
                                    >
                                        {!isSendCode
                                            ? "인증번호 요청"
                                            : "전송 완료"}
                                    </button>
                                </div>
                            </div>
                            <div className="input-form">
                                <input
                                    className={`input ${
                                        isSendCode === false || isLoading
                                            ? "disabled"
                                            : ""
                                    }`}
                                    placeholder="인증번호를 입력하세요"
                                    value={verificationCode}
                                    disabled={isSendCode === false || isLoading}
                                    onChange={(e) =>
                                        setVerificationCode(e.target.value)
                                    }
                                />
                                {helpTxt && (
                                    <p className="validation-error">
                                        {helpTxt}
                                    </p>
                                )}
                            </div>
                        </>
                    ) : (
                        <div className="find-id-result-wrap">
                            <p>
                                입력한 정보로 조회된 아이디는
                                <strong>{myId}</strong>입니다.
                            </p>
                            <p className="subtitle-14">
                                개인정보 보호를 위하여 아이디는 일부만
                                표시됩니다.
                            </p>
                        </div>
                    )}
                </div>
            ) : (
                <div className="find-id-and-pw-wrap">
                    <h2 className="title">{`비밀번호를 재설정합니다.`}</h2>
                    {isVerified === false ? (
                        <>
                            <div className="input-form">
                                <input
                                    className="input input-has-gutter"
                                    placeholder="가입한 아이디를 입력하세요"
                                    value={myId}
                                    onChange={(e) => setMyId(e.target.value)}
                                    disabled={isLoading}
                                />
                            </div>
                            <div className="input-form">
                                <div className="input-has-button">
                                    <input
                                        className="input input-has-gutter"
                                        placeholder="휴대폰 번호를 -없이 입력하세요"
                                        value={phone}
                                        onChange={(e) =>
                                            setPhone(e.target.value)
                                        }
                                        disabled={isLoading}
                                    />
                                    <button
                                        className={`btn btn-fit btn-border-8 ${
                                            isSendCode ? "disabled" : ""
                                        }`}
                                        onClick={sendVerificationCode}
                                        disabled={isLoading}
                                    >
                                        {!isSendCode
                                            ? "인증번호 요청"
                                            : "전송 완료"}
                                    </button>
                                </div>
                            </div>
                            <div className="input-form">
                                <div className="input-has-button">
                                    <input
                                        className={`input ${
                                            isSendCode === false || isLoading
                                                ? "disabled"
                                                : ""
                                        }`}
                                        placeholder="인증번호를 입력하세요"
                                        value={verificationCode}
                                        disabled={
                                            isSendCode === false || isLoading
                                        }
                                        onChange={(e) =>
                                            setVerificationCode(e.target.value)
                                        }
                                    />
                                    <button
                                        className={`btn btn-fit btn-border-8 ${
                                            !verificationCode ? "disabled" : ""
                                        }`}
                                        onClick={handleVerifyCodeForPassword}
                                        disabled={!verificationCode}
                                    >
                                        확인
                                    </button>
                                </div>
                                <p className="validation-error">{helpTxt}</p>
                            </div>
                        </>
                    ) : (
                        <div className="input-form input-has-button">
                            {/* <div className="input-has-button"> */}
                            <input
                                className="input"
                                type="password"
                                placeholder="새로운 비밀번호를 입력하세요"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                disabled={isLoading}
                            />
                            {helpTxt === null ? (
                                <p className="validation-help-txt">
                                    영문, 숫자, 특수문자 포함 8~12자리
                                </p>
                            ) : (
                                <p className="validation-error">{helpTxt}</p>
                            )}
                            {/* </div> */}
                        </div>
                    )}
                </div>
            )}

            {((selectedTab === "아이디 찾기" && myId === null) ||
                (selectedTab === "비밀번호 찾기" && isVerified)) && (
                <div className="btn-wrap">
                    <button
                        className="btn btn-purple500 btn-fit btn-large"
                        onClick={handleFindButton}
                        disabled={isLoading}
                        style={{ minWidth: 120 }}
                    >
                        {selectedTab === "아이디 찾기"
                            ? "아이디 찾기"
                            : "비밀번호 재설정"}
                    </button>
                </div>
            )}
        </>
    );
};

export default FindIdAndPW;
